import React, { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  CModal,
  CModalBody,
  CModalHeader,
} from '@coreui/react';
import { Job } from '../../shared/models/jobs';
import ChatView from './chatView/ChatView';
import { LoadMessages, SubscribeChannel } from '../actions/chat.action';
import { mapJobToChatInfo } from '../../shared/models/chat';
import { selectChatData } from '../selectors/chat.selector';
import { ConfigContext } from '../../shared/contexts/journeyConfig.context';

export interface ViewChatModalProps{
  show: boolean;
  close: () => void;
  job: Job;
}

const ViewChatModal = (props: ViewChatModalProps) => {
  const { show, close, job } = props;
  const labels = useContext(ConfigContext);
  const dispatch = useDispatch();
  const chat = useSelector(selectChatData)(`${job?.chat_channel}`);
  const customer = chat?.chatInfo?.customer;

  useEffect(() => {
    if (!chat && !!job?.start_time) {
      dispatch(new SubscribeChannel({
        chat_channel: `${job?.chat_channel}`,
        chatInfo: mapJobToChatInfo(job),
      }));
      dispatch(new LoadMessages(`${job?.chat_channel}`));
    }
  }, [chat]);

  return (
    show && <CModal key={`${job?.chat_channel}`} className="mt-5 pt-5 chat-view-modal-container" id="chat-view-modal" show={ show } onClose={ close } closeOnBackdrop={ false }>
      <CModalHeader closeButton>{chat?.chatInfo?.appointment_id !== '-' ? `${labels.task} #: ${chat?.chatInfo?.appointment_id} / ` : null} Chat with {customer}</CModalHeader>
      <CModalBody>
        <ChatView activeChatId={`${job?.chat_channel}`}/>
      </CModalBody>
    </CModal>
  );
};

export default ViewChatModal;
